import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const SelectionEventVideoType = (props) => {
	const { name, value, setEventTypes, disabled, labelPosition } = props
	const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionEventVideoType' });

	const setNewValue = (e) => {
		setEventTypes({ [name]: e.target.value })
	}

	return (
		<div className="toggle-wrapper">
			<label className={`settings-title ${!labelPosition ? 'mr10' : labelPosition}`}>{t('uploadType')}</label>
			<select
				placeholder="select"
				className="form-control rosco-select mini inline"
				name={name}
				value={value}
				onChange={setNewValue}
				disabled={disabled}
			>
				<option value="alert_only">{t('alertOnly')}</option>
				<option value="snapshot_only">{t('snapshotOnly')}</option>
				<option value="video_snapshot">{t('videoSnapshot')}</option>
			</select>
		</div>
	)
}

SelectionEventVideoType.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	setEventTypes: PropTypes.func.isRequired,
	labelPosition: PropTypes.string,
}

SelectionEventVideoType.defaultProps = {
	labelPosition: '',
}

export default SelectionEventVideoType;
